export function getRouterBaseName(pathname: string): string {
  const pathItems = pathname.split('/').filter((path) => !!path);
  const widgetPathIndex = pathItems.findIndex((path) => path === 'widget');

  if (widgetPathIndex === -1) {
    return `/${pathItems[0] || ''}`;
  } else {
    return `/${pathItems.slice(0, widgetPathIndex + 1).join('/')}`;
  }
}
